module.exports = __webpack_public_path__ + "img/conveniencias-07.ab26469f.png";